import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {Row, Col} from 'reactstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { ConsultaHelper } from '../../../../shared/helpers';
import Login from '../../pages/auth/Login';
import VisualizadorPdfV2 from '../Home/VisualizadorPdfV2';
import { MediaView } from '../Home/MediaView';

const CampoDadosArquivo = props => {
    const {t} = useTranslation();
    const [isOpenViewPdfRestrictedOnce, setIsOpenViewPdfRestrictedOnce] = useState(null)
    const [isOpenMediaViewOnLogin, setIsOpenMediaViewOnLogin] = useState(undefined)

    const verifyOpen = (seqParagrafo) => {
        if(isOpenMediaViewOnLogin){
            const {seq_paragrafo} = isOpenMediaViewOnLogin;
            if(seqParagrafo === seq_paragrafo){
                return true;
            }
        }

        return false;
    }

    const gerarConteudoParagrafo = (paragrafoData, index , t) => {
        let conteudo = null;
        if(paragrafoData.link) {
            if(paragrafoData.link === 'A') {
                if(paragrafoData.autoridade){
                    conteudo = <Link className="link hover1 f500"
                        title={t("ConsultarPorAutor")}
                        to={`/pesquisa_geral?q=${paragrafoData.descricao}&for=INDICE_3&index=${paragrafoData.autoridade}&research=true`}>
                            {paragrafoData.descricao}
                    </Link>
                } else {
                    conteudo = <Link className="link hover1 f500"
                            title={t("ConsultarPorAutor")}
                            to={`/pesquisa_geral?q=${paragrafoData.descricao}&for=AUTOR&research=true`}>
                                {paragrafoData.descricao}
                        </Link>
                }
            } else if (paragrafoData.link === 'S') {
                if(paragrafoData.autoridade){
                    conteudo = <Link className="link hover1 f500"
                        title={t("ConsultarPorAssunto")}
                        to={`/pesquisa_geral?q=${paragrafoData.descricao}&for=INDICE_2&index=${paragrafoData.autoridade}&research=true`}>
                            {paragrafoData.descricao}
                    </Link>
                } else {
                    conteudo = <Link className="link hover1 f500"
                            title={t("ConsultarPorAssunto")}
                            to={`/pesquisa_geral?q=${paragrafoData.descricao}&for=ASSUNTO&research=true`}>
                                {paragrafoData.descricao}
                        </Link>
                }
            } else if (paragrafoData.link.startsWith("acervo/")){
                conteudo = <Link className="link hover1 f500"
                        title={t("ConsultarAcervo")}
                        to={paragrafoData.link}>
                            {paragrafoData.descricao}
                    </Link>
            } else {
                //Vínculo aqui
                const hrefAncora =
                    paragrafoData.link === 'VB'
                        ? `/vinculos/publico/${props.codAcervo}/seq/${paragrafoData.seqParagrafo}/${paragrafoData.descricao}`
                        : paragrafoData.link;

                if(paragrafoData.link === 'AC'){
                    conteudo = (
                        <>
                            <Login
                                modal
                                openModalRender={() => (
                                    <span
                                        className="link hover1 f500 azul"
                                        title={t('CliqueAcessarMaterialAcessibilidade')}
                                    >
                                        <FontAwesomeIcon
                                            icon="universal-access"
                                            className="s13 r5"
                                        />
                                        {paragrafoData.descricao}
                                    </span>
                                )}
                                altRender={auth => {
                                    const { usa_visualizador_php}  = props?.instituicaoRx
                                    const {is_pdf, link_data} = paragrafoData;

                                    if(auth){
                                        if(is_pdf){
                                            if(usa_visualizador_php === '1'){
                                                return (<span className="f500">
                                                <VisualizadorPdfV2
                                                    codAcervo={props.codAcervo}
                                                    seqParagrafo={paragrafoData.seqParagrafo}
                                                    isRestricted
                                                />
                                                    {paragrafoData.descricao}
                                                </span>)
                                            }
                                        }else if(link_data?.is_media){
                                            return (
                                                <span className="f500">
                                                    <MediaView
                                                        open={verifyOpen(paragrafoData.seqParagrafo)}
                                                        title={paragrafoData.descricao}
                                                        codAcervo={props.codAcervo}
                                                        seqParagrafo={paragrafoData.seqParagrafo}
                                                        isRestricted
                                                        format={paragrafoData.link_data.media_format}
                                                    />
                                                    {paragrafoData.descricao}
                                                 </span>
                                            )
                                        }

                                        return (
                                            <span
                                                className="link hover1 f500 azul"
                                                title={t('CliqueAcessarMaterialAcessibilidade')}
                                                onClick={() =>
                                                    ConsultaHelper.acessarLinkAcessoRestrito(
                                                        props.codAcervo,
                                                        paragrafoData.seqParagrafo,
                                                    )
                                                }
                                            >
                                        <FontAwesomeIcon
                                            icon="universal-access"
                                            className="s13 r5"
                                        />
                                                {paragrafoData.descricao}
                                    </span>
                                        )
                                    }
                                }}
                                loginCallback={() => {
                                    if(paragrafoData?.is_pdf){
                                        const {usa_visualizador_php} = props.instituicaoRx
                                        if((usa_visualizador_php && usa_visualizador_php === '1') || paragrafoData?.download_pdf === 'N'){
                                            setIsOpenViewPdfRestrictedOnce({ seqParagrafo: paragrafoData.seqParagrafo})
                                            return;
                                        }
                                    }else if(paragrafoData?.link_data.is_media){
                                        setIsOpenMediaViewOnLogin({
                                            seq_paragrafo: paragrafoData.seqParagrafo
                                        })
                                        return;
                                    }

                                    ConsultaHelper.acessarLinkAcessoRestrito(props.codAcervo, paragrafoData.seqParagrafo)
                                }}
                            />

                            {
                                isOpenViewPdfRestrictedOnce !== null && isOpenViewPdfRestrictedOnce?.seqParagrafo === paragrafoData.seqParagrafo  ? (
                                    <VisualizadorPdfV2
                                        codAcervo={props.codAcervo}
                                        seqParagrafo={paragrafoData.seqParagrafo}
                                        isRestrictedOnce
                                        setIsOpenViewPdfRestrictedOnce={setIsOpenViewPdfRestrictedOnce}
                                    />
                                ) : ''
                            }
                        </>
                    )
                } else if(paragrafoData.link === 'AR'){
                    conteudo = (
                        <>
                            <Login
                                modal
                                msgErroCustom={paragrafoData?.msg_err_login}
                                openModalRender={() => (
                                    <span
                                        className="link hover1 f500 azul"
                                        title={t('CliqueAcessarMaterialAcessoRestrito')}
                                    >
                                            <FontAwesomeIcon
                                                icon="lock"
                                                className="s13 preto70 r5"
                                            />
                                            {paragrafoData.descricao}
                                        </span>
                                )}
                                altRender={auth => {
                                    if (auth) {
                                        if (paragrafoData.is_pdf) {
                                            const { usa_visualizador_php } = props.instituicaoRx;
                                            if ((usa_visualizador_php && usa_visualizador_php === '1') || paragrafoData?.download_pdf === 'N') {
                                                return (
                                                    <span className="f500">
                                                              <VisualizadorPdfV2
                                                                  codAcervo={props.codAcervo}
                                                                  seqParagrafo={paragrafoData.seqParagrafo}
                                                                  isRestricted
                                                              />
                                                        {paragrafoData.descricao}
                                                    </span>)
                                            }
                                        }else if(paragrafoData?.link_data?.is_media){
                                            return (
                                                <span className="f500">
                                                            <MediaView
                                                                open={verifyOpen(paragrafoData.seqParagrafo)}
                                                                title={paragrafoData.descricao}
                                                                codAcervo={props.codAcervo}
                                                                seqParagrafo={paragrafoData.seqParagrafo}
                                                                isRestricted
                                                                format={paragrafoData.link_data.media_format}
                                                            />
                                                    {paragrafoData.descricao}
                                                </span>
                                            )
                                        }

                                        return (
                                            <span
                                                className="link hover1 f500 azul"
                                                title={t('CliqueAcessarMaterialAcessoRestrito')}
                                                onClick={() =>
                                                    ConsultaHelper.acessarLinkAcessoRestrito(
                                                        props.codAcervo,
                                                        paragrafoData.seqParagrafo,
                                                    )
                                                }
                                            >
                                                    <FontAwesomeIcon
                                                        icon="lock-open"
                                                        className="s13 preto70 r5"
                                                    />
                                                {paragrafoData.descricao}
                                                </span>
                                        )
                                    }
                                }}
                                loginCallback={() => {

                                    if (paragrafoData.is_pdf) {
                                        const { usa_visualizador_php } = props.instituicaoRx
                                        if ((usa_visualizador_php && usa_visualizador_php === '1') || paragrafoData?.download_pdf === 'N') {
                                            setIsOpenViewPdfRestrictedOnce({ seqParagrafo: paragrafoData.seqParagrafo })
                                            return;
                                        }
                                    }else if(paragrafoData.link_data.is_media){
                                        setIsOpenMediaViewOnLogin({
                                            seq_paragrafo: paragrafoData.seqParagreafo,
                                        })
                                        return;
                                    }

                                    ConsultaHelper.acessarLinkAcessoRestrito(props.codAcervo, paragrafoData.seq_paragrafo)

                                }}
                            />

                            {
                                isOpenViewPdfRestrictedOnce !== null && isOpenViewPdfRestrictedOnce?.seqParagrafo === paragrafoData.seqParagrafo ? (
                                    <VisualizadorPdfV2
                                        codAcervo={props.codAcervo}
                                        seqParagrafo={paragrafoData.seqParagrafo}
                                        isRestrictedOnce
                                        setIsOpenViewPdfRestrictedOnce={setIsOpenViewPdfRestrictedOnce}
                                    />
                                ) : ''
                            }

                        </>
                    )
                } else {
                    if (props.instituicaoRx.usa_visualizador_php &&
                        props.instituicaoRx.usa_visualizador_php === '1' &&
                        paragrafoData.is_pdf) {
                        conteudo = <span className="f500">
                            <VisualizadorPdfV2
                                descricao={paragrafoData.descricao}
                                urlPdf={hrefAncora}
                            />
                            {paragrafoData.descricao}
                        </span>
                    } else if(paragrafoData?.link_data?.is_media){
                        return (
                            <span className="f500">
                                     <MediaView
                                         title={paragrafoData.descricao}
                                         format={paragrafoData.link_data.format_type}
                                         uri={paragrafoData.link_data.url_link}
                                     />
                                {paragrafoData.descricao}
                            </span>
                        )
                    } else {
                        conteudo = <span className="f500 azul link hover1"
                                         onClick={() =>
                                             ConsultaHelper.acessarVinculo(
                                                 props.codAcervo,
                                                 paragrafoData.seqParagrafo,
                                                 hrefAncora,
                                             )
                                         }
                        >
                            <FontAwesomeIcon icon="link" className="s13 preto70 r5" />
                            {paragrafoData.descricao}
                        </span>;
                    }
                }
            }
        } else {
            conteudo = <span className="f500">{paragrafoData.descricao}</span>;
        }

        return (
            <Row key={`PARAGRAFO__${paragrafoData.paragrafo}${index}`} className="pt-2 pb-2">
                <Col md="3" xs="12">
                    <span className="f400 preto70 s14">{paragrafoData.titulo ? `${paragrafoData.titulo}: ` : ''} </span>
                </Col>
                <Col md="9" xs="12">
                    {conteudo}
                </Col>
            </Row>
        )
    }

    return (
        <Row className="b-w1 b-cinza2 b-solid-bottom pad5 b5">
            <Col xs="12" md="12">
                <FontAwesomeIcon icon="chevron-right" className="cortxt s20 r10" />
                <span className="f500 cortxt s16">{props.campo.grupo} </span>
            </Col>
            <Col xs="12" md={{ size: 11, offset: 1 }}>
                {props.campo.paragrafos.map((paragrafo, index) =>
                    gerarConteudoParagrafo(paragrafo, index, t)
                )
                }
            </Col>
        </Row>
    );
}

CampoDadosArquivo.propTypes = {
    campo: PropTypes.object.isRequired
}

function mapStateToProps(state) {
    return {
        instituicaoRx: state.instituicao.data,
    };
}

export default connect(mapStateToProps)(CampoDadosArquivo);
